const menu = [
  {
    key: 'shipment',
    label: 'Shipments',
    translationKey: 'app.navigation.main.shipments',
    to: '/shipments',
    exact: false,
  },
  {
    key: 'handlingLists',
    label: 'Handling lists',
    translationKey: 'app.navigation.main.handlingLists',
    to: '/handling-lists',
    exact: false,
  },
  {
    key: 'parcels',
    label: 'Parcels',
    translationKey: 'app.navigation.main.parcels',
    to: '/parcels',
    exact: false,
  },
  {
    key: 'parkParcels',
    label: 'Park parcels',
    translationKey: 'app.navigation.main.parkParcels',
    to: '/park-parcels',
    exact: false,
  },
  {
    key: 'packing',
    label: 'Packing',
    translationKey: 'app.navigation.main.packing',
    to: '/packing',
    exact: false,
  },
  {
    key: 'batches',
    label: 'Batches',
    translationKey: 'app.navigation.main.batches',
    to: '/batches',
    exact: false,
  },
  {
    key: 'settings',
    label: 'Settings',
    translationKey: 'app.navigation.main.settings',
    to: '/settings',
    exact: false,
  },
];

export default menu;
